import { NotifyHelper } from "../../../helpers/toast";
import { eHoaDonDieuChinhThuCongActionsObj } from "../../action-types/hoa-don/IHoaDonDieuChinhThuCongAction";
import { generateActionForKey, generateActions } from "../generateActions";

const KEY = "HOA_DON_DIEU_CHINH_THU_CONG";

export const hoaDonDieuChinhThuCongActions = {
  ...generateActions(eHoaDonDieuChinhThuCongActionsObj, KEY),
  ...generateActionForKey(eHoaDonDieuChinhThuCongActionsObj, KEY, "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Đã lưu điều chỉnh");
  }),
  ...generateActionForKey(eHoaDonDieuChinhThuCongActionsObj, KEY, "SAVE_ERROR", (m: string) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eHoaDonDieuChinhThuCongActionsObj, KEY, "HUY_SUCCESS", () => {
    NotifyHelper.Success("Đã hủy lần điều chỉnh");
  }),
  ...generateActionForKey(eHoaDonDieuChinhThuCongActionsObj, KEY, "HUY_ERROR", (m: string) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eHoaDonDieuChinhThuCongActionsObj, KEY, "LOAD_ERROR", (m: string) => {
    NotifyHelper.Error(m);
  }),
};
